import React from 'react';
import { Cpu, User } from 'lucide-react';

const ComparisonAnalysisCard = ({ referenceSynopsis, generatedSynopsis }) => {
  return (
    <div className="bg-white dark:bg-neutral-950 rounded-lg border border-gray-200 dark:border-neutral-800 overflow-hidden shadow-sm">
      <div className="p-4 border-b border-gray-200 dark:border-neutral-800 bg-gray-50/50 dark:bg-neutral-900/50 flex justify-between items-center">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-neutral-100 flex items-center">
          <User className="w-5 h-5 mr-2 text-amber-600" />
          Comparison Analysis
        </h2>
      </div>
      
      <div className="p-4 space-y-8">
        {/* Side-by-side View */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Reference (Human) */}
          <div className="space-y-3">
            <div className="flex items-center space-x-2 text-amber-600 dark:text-amber-400">
              <User className="w-4 h-4" />
              <h3 className="text-sm font-semibold tracking-wider text-gray-500 dark:text-neutral-400">Reference Synopsis</h3>
            </div>
            <div className="bg-amber-50/30 dark:bg-amber-900/5 border border-amber-100 dark:border-amber-900/30 rounded-xl p-4 min-h-[200px]">
              <p className="text-sm text-gray-800 dark:text-neutral-200 whitespace-pre-wrap leading-relaxed">
                {referenceSynopsis || 'No reference synopsis provided.'}
              </p>
            </div>
          </div>

          {/* Generated (AI) */}
          <div className="space-y-3">
            <div className="flex items-center space-x-2 text-sky-600 dark:text-sky-400">
              <Cpu className="w-4 h-4" />
              <h3 className="text-sm font-semibold tracking-wider text-gray-500 dark:text-neutral-400">AI Generated</h3>
            </div>
            <div className="bg-sky-50/30 dark:bg-sky-900/5 border border-sky-100 dark:border-sky-900/30 rounded-xl p-4 min-h-[200px]">
              <p className="text-sm text-gray-800 dark:text-neutral-200 whitespace-pre-wrap leading-relaxed">
                {generatedSynopsis || 'No AI synopsis generated yet.'}
              </p>
            </div>
          </div>
        </div>

        {/* Textual Analysis removed - now handled in parent layout */}
      </div>
    </div>
  );
};

export default ComparisonAnalysisCard;

